// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wobbuffet: PokeData = {
  "id": 202,
  "name": "wobbuffet",
  "height": 13,
  "weight": 285,
  "base_experience": 142,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "counter",
    "amnesia",
    "splash",
    "destiny-bond",
    "charm",
    "safeguard",
    "encore",
    "mirror-coat"
  ],
  "moves": [
    "splash",
    "psywave",
    "psy-pulse",
    "prismatic-cage",
    "psychic-terrain",
    "reflect",
    "psychic",
    "zen-headbutt",
    "calm-mind",
    "psychic-fangs",
    "future-sight",
    "synchronize",
    "kinesis"
  ],
  "evolution_chain": {
    "id": 100,
    "item": {
      "name": "lax-incense"
    },
    "species": [
      {
        "name": "wynaut",
        "order": 232,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "wobbuffet",
        "order": 233,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 360,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 15,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 248,
    "speed": 66,
    "ability_power": 66
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
